import React from 'react';

import { OrderProps, TrackerProps } from '@/types/common';
import { getTrans } from '@/utils/tools';
import { ORDER_ID_TRANSIFY_KEY, TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { handleOrderRedirect } from '@/utils/btnClickHandler';
import { inject, observer } from 'mobx-react';
import { tracker } from '@/utils/tracking';
import { InitStoreType } from '@/types/store/init';
import { getChildInject } from '@/utils/instantLoaded/tools';

import Order from '@/components/Order';

import './style.scss';

const PREFIX = 'order-card-sn';

export type OrderCardWithSNProps = {
  nodePointId: string;
  dialogueId: string;
  dialogueType: string;
  msgContent: string;
  order: OrderProps;
  isHistory: boolean;

  historyDialogueId?: string;
  historySessionId?: string;

  initStore: InitStoreType;
} & TrackerProps;

function OrderCardWithSN(props: OrderCardWithSNProps) {
  const trackingname = TRACKING_TYPE.SINGLE_ORDER_CARD;
  const trackingdata = {
    orderid: props.order?.order_id,
    chat_session_id: props.isHistory ? props.historySessionId : props.initStore.sessionId,
    chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
    node_point_id: props.nodePointId,
    if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
  };

  const handleClick = () => {
    props.initStore.UPDATE_DONT_SCROLL_TO_BOTTOM(true);
    handleOrderRedirect(props.order, { trackingname, trackingdata });
  };

  return (
    <div
      ref={props.passedRef}
      className={PREFIX}
      data-trackingname={trackingname}
      data-trackingdata={JSON.stringify(trackingdata)}
      onClick={handleClick}
    >
      <div className={`${PREFIX}__title`}>
        <div className="title-content">
          {getTrans(ORDER_ID_TRANSIFY_KEY)}:
        </div>
        <div className="title-sn">
          {props.order.order_sn}
        </div>
      </div>
      <Order {...props.order} />
    </div>
  );
}

export default tracker(inject(getChildInject('initStore'))(observer(OrderCardWithSN)));
